// extracted by mini-css-extract-plugin
module.exports = {"result":"result--LnKkGP","item":"item--DLyR6Z","icon":"icon--EfhROi","distance":"distance--toW2Vp","storeText":"storeText--r8EuzH","selected":"selected--lhiwf_"};